import { combineReducers } from "@reduxjs/toolkit";
import { userReducer } from "./userReducer.js";
import { localeReducer } from "./localeReducer.js";
import { styleReducer } from "./styleReducer.js";
import { apiKeyReducer } from "./apiKeyReducer.js";

export const rootReducer = combineReducers({
  user: userReducer,
  locale: localeReducer,
  style: styleReducer,
  apiKey: apiKeyReducer,
});
